import React, { PureComponent } from 'react';
import _ from 'lodash';
import { Col, Row } from 'react-bootstrap';

import { TipoDeRelacion } from '../../../../support/catalogs/TipoDeRelacion';

class CfdisRelacionadosList extends PureComponent {

  get description() {
    const { TipoRelacion } = this.props.data;

    return _.find(TipoDeRelacion, { clave: TipoRelacion })?.descripcion;
  }

  render() {
    const { TipoRelacion, CfdiRelacionado } = this.props.data;

    return (
      <Row>
        <Col>
          <div className="py-3">
            <strong>Tipo de relación: </strong> { TipoRelacion } - { this.description }
          </div>
          <div>
            { CfdiRelacionado.map((item) => <p key={ item.UUID }>{ item.UUID }</p>) }
          </div>
        </Col>
      </Row>
    )
  }
}

export default CfdisRelacionadosList;